import { DocumentWorkspace } from '@widgets/document-workspace';

const HomePage: React.FC = () => {
  return <DocumentWorkspace />;
};

export default HomePage;
